import LinkCTA from '2-core-elements/LinkCTA/LinkCTA';
import { useDonationNavigation } from '../libs/useDonationNavigation';
import { type ReactNode } from 'react';

interface ButtonBackProps {
    children: ReactNode;
}

const ButtonBack = ({ children }: ButtonBackProps): JSX.Element => {
    const { prevStep } = useDonationNavigation();

    return (
        <LinkCTA
            prefixIcon={'arrow-left'}
            onClick={(): void => {
                prevStep();
            }}
        >
            {children}
        </LinkCTA>
    );
};

export default ButtonBack;
